import dayjs from 'dayjs';
import { formatCurrency, formatDate, parseNumber } from 'helper';

export const transformCashbackPayload = (payload) => ({
  title: payload?.title,
  amount: payload?.amount,
  amount_type: payload?.amount_type,
  minimum_range_amount: parseNumber(payload?.minimum_range_amount),
  maximum_range_amount: parseNumber(payload?.maximum_range_amount),
  status: payload?.status ? 'active' : 'inactive',
  validity_start_date: payload?.validity_start_date
    ? dayjs(payload?.validity_start_date).format('DD/MM/YYYY')
    : '',
  validity_end_date: payload?.validity_end_date
    ? dayjs(payload?.validity_end_date).format('DD/MM/YYYY')
    : '',
});

export const transformCashback = (raw) => ({
  uuid: raw?.uuid,
  status: raw?.status,
  title: raw?.title,
  amount: raw?.amount,
  amount_human: formatCurrency(raw?.amount),
  amount_type: raw?.amount_type,
  minimum_range_amount: raw?.minimum_range_amount,
  maximum_range_amount: raw?.maximum_range_amount,
  minimum_range_amount_human: formatCurrency(
    parseNumber(raw?.minimum_range_amount, 0)
  ),
  maximum_range_amount_human: formatCurrency(
    parseNumber(raw?.maximum_range_amount, 0)
  ),
  validity_start_date: raw?.validity_start_date,
  validity_end_date: raw?.validity_end_date,
  validity_start_date_human: formatDate(raw?.validity_start_date, 'DD/MM/YYYY'),
  validity_end_date_human: formatDate(raw?.validity_end_date, 'DD/MM/YYYY'),
});
